/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Ai_IntroInputs */

const en_directory_hubs_signals_ai_intro = /** @type {(inputs: Directory_Hubs_Signals_Ai_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Ready measures whether an autonomous agent can operate a product end-to-end. Agents fail in a predictable order: they cannot find the product's machine surface, cannot learn it, cannot operate it, or cannot verify what they did. The score follows that journey — discover, learn, operate, verify — instead of checking whether an API merely exists.`)
};

const zh_directory_hubs_signals_ai_intro = /** @type {(inputs: Directory_Hubs_Signals_Ai_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Ready 衡量自主 Agent 能否端到端地操作一个产品。Agent 的失败顺序是可预测的：找不到产品的机器入口、学不会、操作不了、或者无法验证自己做了什么。评分沿这条路径展开——发现、学习、操作、验证——而不是只检查“有没有 API”。`)
};

/**
* | output |
* | --- |
* | "AI-Ready measures whether an autonomous agent can operate a product end-to-end. Agents fail in a predictable order: they cannot find the product's machine su..." |
*
* @param {Directory_Hubs_Signals_Ai_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_ai_intro = /** @type {((inputs?: Directory_Hubs_Signals_Ai_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Ai_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_ai_intro(inputs)
	return zh_directory_hubs_signals_ai_intro(inputs)
});
export { directory_hubs_signals_ai_intro as "directory.hubs.signals.ai.intro" }